export enum CountryMarketUrl {
  Empty = '/choose-country-market/empty',
  Invalid = '/choose-country-market/invalid',
  NotAvailable = '/no-available-country-market',
}
